import { render, staticRenderFns } from "./OrderPdf.vue?vue&type=template&id=8d8d32c2&scoped=true"
import script from "./OrderPdf.vue?vue&type=script&lang=js"
export * from "./OrderPdf.vue?vue&type=script&lang=js"
import style0 from "./OrderPdf.vue?vue&type=style&index=0&id=8d8d32c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8d32c2",
  null
  
)

export default component.exports